// 📄 useChecklistIncidentAlerts.ts
import { useEffect, useState } from 'react';
import { getIncidentes, Incidente } from '../../../../services/incidenteService.ts';

/**
 * Mapa checklistStepKey -> Incidente abierto en DEV/QAS para ese paso.
 * Solo hace fetch cuando `enabled` es true (el consultor está viendo PRD),
 * igual que el resto del código de checklist no usa listeners en tiempo
 * real, solo fetch puntual (ver useGeneralConfig.ts).
 */
export function useChecklistIncidentAlerts(projectId: string | undefined, enabled: boolean): Record<string, Incidente> {
  const [alerts, setAlerts] = useState<Record<string, Incidente>>({});

  useEffect(() => {
    if (!projectId || !enabled) {
      setAlerts({});
      return;
    }

    let cancelled = false;
    getIncidentes(projectId).then(incidentes => {
      if (cancelled) return;
      const map: Record<string, Incidente> = {};
      for (const i of incidentes) {
        if (
          i.fase === 'Proyecto' &&
          i.solucionRelacionada === 'commerce' &&
          i.checklistStepKey &&
          (i.ambiente === 'DEV' || i.ambiente === 'QAS') &&
          i.estado !== 'Resuelto' && i.estado !== 'Cerrado' &&
          !map[i.checklistStepKey]
        ) {
          map[i.checklistStepKey] = i;
        }
      }
      setAlerts(map);
    }).catch(err => console.error('Error cargando alertas de incidentes:', err));

    return () => { cancelled = true; };
  }, [projectId, enabled]);

  return alerts;
}
